const PDFJs = require('pdfjs-dist');


/*! Angular-PDF Version: 1.2.0 | (C) Sayanee Basu 2015, released under an MIT license */

// angular
//     .module("HeroPRO")
//     .directive('ngPdf', ngPdf);

/* @ngInject */
export default function ngPdf($window, $rootScope) {
    const backingScale = function (canvas) {
        const ctx = canvas.getContext('2d');
        const dpr = $window.devicePixelRatio || 1;
        const bsr = ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio ||
            ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio ||
            ctx.backingStorePixelRatio || 1;

        return dpr / bsr;
    };

    const setCanvasDimensions = function (canvas, w, h) {
        const ratio = backingScale(canvas);
        canvas.width = Math.floor(w * ratio);
        canvas.height = Math.floor(h * ratio);
        canvas.style.width = `${Math.floor(w)}px`;
        canvas.style.height = `${Math.floor(h)}px`;
        canvas.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0);
        return canvas;
    };
    return {
        restrict: 'E',
        templateUrl(element, attr) {
            return attr.templateUrl ? attr.templateUrl : 'partials/viewer.html';
        },
        link(scope, element, attrs) {
            let url = scope.pdfUrl;
            let pdfDoc = null;
            const pageNum = (attrs.page ? attrs.page : 1);
            let scale = attrs.scale > 0 ? attrs.scale : 1;
            const canvas = (attrs.canvasid ? $window.document.getElementById(attrs.canvasid) : $window.document.getElementById('pdf-canvas'));
            const ctx = canvas.getContext('2d');
            const windowEl = angular.element($window);

            windowEl.on('scroll', () => {
                scope.$apply(() => {
                    scope.scroll = windowEl[0].scrollY;
                });
            });

            PDFJS.disableWorker = true;
            scope.pageNum = pageNum;

            scope.renderPage = function (num) {
                pdfDoc.getPage(num).then((page) => {
                    let viewport;
                    let pageWidthScale;
                    let pageHeightScale;
                    let renderContext = {};

                    if (attrs.scale === 'page-fit' && !scale) {
                        viewport = page.getViewport(1);
                        pageWidthScale = element[0].clientWidth / viewport.width;
                        pageHeightScale = element[0].clientHeight / viewport.height;
                        scale = Math.min(pageWidthScale, pageHeightScale);
                    } else {
                        viewport = page.getViewport(scale);
                    }

                    setCanvasDimensions(canvas, viewport.width, viewport.height);

                    renderContext = {
                        canvasContext: ctx,
                        viewport,
                    };

                    page.render(renderContext).promise.then(() => {
                        if (typeof scope.onPageRender === 'function') {
                            scope.onPageRender();
                        }
                    });
                });
            };

            scope.getArrayNumPages = function () {
                if (pdfDoc !== null) {
                    return new Array(parseInt(pdfDoc.numPages));
                }
            };

            scope.goPrevious = function () {
                if (scope.pageToDisplay <= 1) {
                    return;
                }
                scope.pageNum = parseInt(scope.pageNum) - 1;
            };

            scope.goNext = function () {
                if (scope.pageToDisplay >= pdfDoc.numPages) {
                    return;
                }
                scope.pageNum = parseInt(scope.pageNum) + 1;
            };

            scope.goToPage = function (newPageNum) {
                scope.pageNum = parseInt(newPageNum);
            };

            scope.getCurrentPage = function () {
                return scope.pageToDisplay;
            };

            scope.zoomIn = function () {
                scale = parseFloat(scale) + 0.2;
                scope.renderPage(scope.pageToDisplay);
                return scale;
            };

            scope.zoomOut = function () {
                scale = parseFloat(scale) - 0.2;
                scope.renderPage(scope.pageToDisplay);
                return scale;
            };

            scope.changePage = function () {
                scope.renderPage(scope.pageToDisplay);
            };

            scope.rotate = function () {
                if (canvas.getAttribute('class') === 'rotate0') {
                    canvas.setAttribute('class', 'rotate90');
                } else if (canvas.getAttribute('class') === 'rotate90') {
                    canvas.setAttribute('class', 'rotate180');
                } else if (canvas.getAttribute('class') === 'rotate180') {
                    canvas.setAttribute('class', 'rotate270');
                } else {
                    canvas.setAttribute('class', 'rotate0');
                }
            };

            function renderPDF() {
                if (url && url.length) {
                    const params = {
                        url,
                        withCredentials: false,
                    };
                    PDFJS.getDocument(params, null, null, scope.onProgress).then((_pdfDoc) => {
                        if (typeof scope.onLoad === 'function') {
                            scope.onLoad();
                        }

                        pdfDoc = _pdfDoc;
                        scope.renderPage(scope.pageToDisplay);

                        scope.$apply(() => {
                            scope.pageCount = _pdfDoc.numPages;
                        });
                    }, (error) => {
                        $rootScope.$broadcast('PDFPreviewError', error);
                        if (error) {
                            if (typeof scope.onError === 'function') {
                                scope.onError(error);
                            }
                        }
                    });
                }
            }

            scope.$watch('pageNum', (newVal) => {
                scope.pageToDisplay = parseInt(newVal);
                if (pdfDoc !== null) {
                    scope.renderPage(scope.pageToDisplay);
                }
            });

            scope.$watch('pdfUrl', (newVal) => {
                if (newVal !== '') {
                    // console.log('pdfUrl value change detected: ', scope.pdfUrl);
                    url = newVal;
                    scope.pageToDisplay = 1;
                    renderPDF();
                }
            });
        },
    };
}




// WEBPACK FOOTER //
// ./src/app/common/angular/ngPDFDirective.js